import heroImg from "@/assets/images/hero.png";
import photoboothImg from "@/assets/images/photobooth.png";
import mosaicImg from "@/assets/images/mosaic.png";
import deliveryImg from "@/assets/images/delivery.png";
import inviteImg from "@/assets/images/invite.png";
import galleryImg from "@/assets/images/gallery.png";
import magnetImg from "@/assets/images/magnet.png";
import arInviteImg from "@/assets/images/ar_invite.png";
import arAlbumImg from "@/assets/images/ar_album.jpg";
import g7Img from "@/assets/images/g7.png";
import g8Img from "@/assets/images/g8.png";
import g9Img from "@/assets/images/g9.png";
import g10Img from "@/assets/images/g10.png";
import g11Img from "@/assets/images/g11.png";
import g12Img from "@/assets/images/g12.png";
import g13Img from "@/assets/images/g13.png";
import teamImg from "@/assets/images/team.png";

export const BRAND = {
  name: "KV Eventech",
  tagline: "Moments that last forever.",
  phone: "+918688832528",
  phoneDisplay: "+91 86888 32528",
  email: "hello@kveventech.in",
  whatsapp: "918688832528",
  city: "Visakhapatnam, Andhra Pradesh",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1757017199822-beab923a1afc?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroAlt: arInviteImg,
  arAlbum: arAlbumImg,
  basic: photoboothImg,
  ai: inviteImg,
  mosaicDigital: mosaicImg,
  mosaicPhysical: mosaicImg,
  magazine: photoboothImg,
  delivery: deliveryImg,
  gallery: galleryImg,
  team: teamImg,
  g1: photoboothImg,
  g2: mosaicImg,
  g3: deliveryImg,
  g4: inviteImg,
  g5: galleryImg,
  g6: magnetImg,
  g7: g7Img,
  g8: g8Img,
  g9: g9Img,
  g10: g10Img,
  g11: g11Img,
  g12: g12Img,
  g13: g13Img,
  magnet: magnetImg,
};

export const SERVICES = [
  {
    slug: "signature-photobooths",
    num: "01",
    kicker: "Classic & Interactive",
    title: "Signature Photobooths",
    tagline: "Where every click becomes a keepsake — timeless, elegant, and instantly yours.",
    img: IMG.basic,
    short: "From classic DSLR setups to Vogue-style magazine booths, we capture the joy of your event with stunning quality and instant physical prints.",
    tags: ["Basic", "AI", "Magazine", "DSLR Quality"],
    specs: [
      { k: "Options", v: "Basic, AI, Magazine" },
      { k: "Print Time", v: "15–30 Seconds" },
      { k: "Resolution", v: "Studio Quality" },
      { k: "Output", v: "Print + Digital" },
    ],
    features: [
      { t: "Basic Photobooth", d: "Classic DSLR camera setup with instant high-quality prints and curated backdrops." },
      { t: "AI Photobooth", d: "Next-gen generative AI turns ordinary photos into stylised masterpieces in real-time." },
      { t: "Magazine Photobooth", d: "Editorial experience where photos are composited into designed magazine covers." },
      { t: "Instant Prints", d: "Dye-sublimation prints delivered in seconds for your guests to keep." },
    ],
    perfectFor: ["Weddings", "Corporate Galas", "Birthdays", "Brand Activations"],
  },
  {
    slug: "mosaic-walls",
    num: "02",
    kicker: "Live Event Display",
    title: "Mosaic Walls",
    tagline: "A living canvas built by the people who matter most.",
    img: IMG.mosaicDigital,
    short: "Guest photos tile into a live mosaic revealing a custom master image. Available as a physical wall or real-time digital display.",
    tags: ["Digital", "Physical", "Interactive", "Grand Reveal"],
    specs: [
      { k: "Formats", v: "Digital & Physical" },
      { k: "Update Speed", v: "Real-Time" },
      { k: "Max Photos", v: "Unlimited" },
      { k: "Final Output", v: "Master Artwork" },
    ],
    features: [
      { t: "Digital Mosaic", d: "Photos populate a large LED screen live as they are taken, building a master image." },
      { t: "Physical Mosaic", d: "Guests physically place printed photo tiles onto a numbered grid revealing the artwork." },
      { t: "QR Upload Support", d: "Guests can instantly upload photos directly from their own phones." },
      { t: "Grand Reveal", d: "A spectacular coordinated reveal at a chosen moment in your event." },
    ],
    perfectFor: ["Weddings", "Annual Days", "Milestones", "Exhibitions"],
  },
  {
    slug: "live-ai-delivery",
    num: "03",
    kicker: "Frictionless Delivery",
    title: "Live AI Delivery",
    tagline: "Captured, enhanced, and in your pocket — instantly.",
    img: IMG.delivery,
    short: "Why wait weeks for event photos? Our AI facial recognition instantly finds and delivers photos of your guests directly to their phones in real-time.",
    tags: ["Face Recognition", "WhatsApp", "AI Enhanced", "Live Updates"],
    specs: [
      { k: "Delivery", v: "Real-Time" },
      { k: "Method", v: "WhatsApp / SMS" },
      { k: "Tech", v: "AI Face Recognition" },
      { k: "Enhancement", v: "Auto-Retouching" },
    ],
    features: [
      { t: "Facial Recognition", d: "AI automatically scans the event gallery and matches faces to guests." },
      { t: "WhatsApp Delivery", d: "Personalised galleries sent directly to guest phones within seconds." },
      { t: "AI Auto-Enhancement", d: "Skin, exposure, and sharpening are fully automatic for perfect shots." },
      { t: "Zero Friction", d: "No apps to download. Guests just take a selfie to register." },
    ],
    perfectFor: ["Weddings", "Conferences", "VIP Parties", "Large Scale Events"],
  },
  {
    slug: "smart-event-invitations",
    num: "04",
    kicker: "Smart & Personalized",
    title: "Smart Event Invitations",
    tagline: "Breathtaking digital invitations that set the perfect tone for your event.",
    img: IMG.ai,
    short: "Move beyond boring text messages. We craft beautiful, personalized AI digital invitations for your guests, perfectly themed and instantly accessible.",
    demoLink: "/invite/demo",
    tags: ["AI Generation", "Custom Themes", "Rich Previews"],
    specs: [
      { k: "Format", v: "Digital Web Link" },
      { k: "Previews", v: "WhatsApp Optimized" },
      { k: "Theme", v: "Fully Custom" },
      { k: "Access", v: "All Devices" },
    ],
    features: [
      { t: "Immersive Web Experience", d: "Full-screen digital invitations that feel like a premium app." },
      { t: "Rich Social Previews", d: "Looks stunning when shared via WhatsApp, iMessage, or Instagram." },
      { t: "Custom Theming", d: "Colors, typography, and AI imagery tailored to your exact event." },
      { t: "Interactive Elements", d: "Embedded maps, RSVP buttons, and event itineraries." },
    ],
    perfectFor: ["Luxury Weddings", "Corporate Events", "Exclusive Parties"],
  },
  {
    slug: "ai-digital-event-galleries",
    num: "05",
    kicker: "Premium Client Portfolios",
    title: "AI Digital Event Galleries",
    tagline: "A stunning, private digital home for your event's memories.",
    img: IMG.gallery,
    short: "Our beautifully designed gallery spaces allow you to view, share, and relive every moment. Powered by AI face recognition to instantly find your photos.",
    demoLink: "/photos/demo",
    tags: ["Face Recognition", "Secure Access", "Instant Sharing"],
    specs: [
      { k: "Tech", v: "AI Face Scanning" },
      { k: "Access", v: "Secure Link" },
      { k: "Quality", v: "High Definition" },
      { k: "Platform", v: "Web & Mobile" },
    ],
    features: [
      { t: "AI Face Scanning", d: "Guests simply upload a selfie to instantly find every photo they appear in." },
      { t: "Secure & Private", d: "Your memories are safely stored in a private, unlisted portfolio." },
      { t: "High Definition", d: "Uncompressed viewing experience so every detail shines." },
      { t: "Instant Sharing", d: "One-click downloading and sharing to social media." },
    ],
    perfectFor: ["Weddings", "Brand Activations", "Corporate Retreats"],
  },
  {
    slug: "photo-magnets",
    num: "06",
    kicker: "Unique Keepsakes",
    title: "Photo Magnets",
    tagline: "A little piece of the event — straight on your fridge, forever.",
    img: IMG.magnet,
    short: "Ditch the boring print. We create stunning, personalised photo magnets on the spot that guests proudly take home as the most unique event keepsake.",
    tags: ["Instant Print", "Custom Design", "Keepsake"],
    specs: [
      { k: "Print Time", v: "Under 30 Sec" },
      { k: "Size", v: "Custom Sizes" },
      { k: "Finish", v: "Gloss / Matte" },
      { k: "Branding", v: "Fully Custom" },
    ],
    features: [
      { t: "Instant Magnet Prints", d: "High-quality photo magnets printed and handed to guests within seconds." },
      { t: "Custom Branded Design", d: "Your event name, logo, and colours beautifully incorporated into every magnet." },
      { t: "Multiple Sizes", d: "From pocket-sized mementos to large statement pieces for the fridge." },
      { t: "Gloss & Matte Finish", d: "Premium finish options so every magnet looks and feels luxurious." },
    ],
    perfectFor: ["Weddings", "Birthdays", "Corporate Events", "School Events"],
  },
  {
    slug: "ar-photo-album",
    num: "07",
    kicker: "Living Memories",
    title: "AR Photo Album",
    tagline: "Scan your printed pages and watch your memories magically come to life.",
    img: IMG.arAlbum,
    short: "Bring your printed photo albums into the future. With our Augmented Reality technology, simply point your phone at the physical pages to reveal hidden video memories, audio messages, and immersive highlights playing right off the paper.",
    demoLink: "/ar/vishika-birthday",
    tags: ["Augmented Reality", "Living Album", "WOW Factor"],
    specs: [
      { k: "Tech", v: "Augmented Reality" },
      { k: "Trigger", v: "Printed Photos" },
      { k: "Content", v: "Video & Audio" },
      { k: "Format", v: "Physical Book" },
    ],
    features: [
      { t: "Living Photos", d: "Point your phone at the album page and watch the static photo seamlessly transition into a playing video." },
      { t: "Audio Memories", d: "Relive the exact moments with embedded speeches, vows, and ambient audio from your event." },
      { t: "Seamless Tracking", d: "The digital video perfectly tracks the physical page, staying anchored even as you move or tilt the book." },
      { t: "Premium Keepsake", d: "A luxury printed photo album that doubles as an interactive, multi-sensory experience." },
    ],
    perfectFor: ["Luxury Weddings", "Anniversaries", "Milestone Birthdays"],
  },
];

export const TESTIMONIALS = [
  { q: "The AI Photobooth was the highlight of our corporate gala. Guests were absolutely mesmerised — a futuristic touch that matched our brand perfectly.", n: "Priya Sharma", t: "Head of Events, TechCorp India" },
  { q: "The mosaic wall was a dream. By the end of the wedding, we had this stunning piece of art made entirely of our guests' photos. Truly magical.", n: "Arjun & Meera Reddy", t: "Wedding, Hyderabad" },
  { q: "Instant delivery to phones meant everyone was sharing their photos live on Instagram during the event. The engagement was off the charts.", n: "Kavitha Nair", t: "Marketing Director, FashionWeek" },
  { q: "The Magazine Photobooth made every guest feel like a celebrity. The prints were framed within the week. KV Eventech exceeded every expectation.", n: "Ravi Chandra", t: "CEO, Luxury Hotels Group" },
];

export const PROCESS = [
  { r: "I", t: "Consultation", d: "Tell us your vision, theme, and guest count. We'll recommend the perfect service combo." },
  { r: "II", t: "Customisation", d: "We design branded templates, overlays and backdrops tailored to your event." },
  { r: "III", t: "Event Day", d: "Our team arrives early, sets up flawlessly, and operates through your event." },
  { r: "IV", t: "Delivery", d: "Guests receive instant prints and digital copies. Full gallery within 24 hours." },
];

export const PAGE_CONTENT = {
  home: {
    hero: {
      kicker: "Premium Event Experiences",
      title1: "Moments",
      title2: "that",
      title3: "last",
      title4: "forever.",
      desc: "Where cutting-edge technology meets timeless elegance. We craft immersive photo experiences that transform events into heirlooms.",
    },
    services: {
      kicker: "Our Offerings",
      title1: "Seven ways to make",
      title2: "magic happen",
    },
    whyUs: {
      kicker: "Why KV Eventech",
      title1: "More than a",
      title2: "photobooth.",
      desc: "We don't set up equipment — we craft experiences. Every event is approached with a director's eye and an artist's soul, ensuring every frame tells your story.",
      features: [
        { s: "✦", t: "White-Glove Setup", d: "Our team handles every detail from install to teardown." },
        { s: "◈", t: "Full Custom Branding", d: "Overlays, templates and backdrops built to your aesthetic." },
        { s: "⬡", t: "State-of-the-Art Tech", d: "From DSLR to AI — professional-grade every time." },
        { s: "◇", t: "Instant Digital Gallery", d: "Private online gallery for guests to access and share." },
      ]
    },
    process: {
      kicker: "How It Works",
      title1: "Simple. Seamless.",
      title2: "Spectacular.",
    },
    galleryStrip: {
      kicker: "Captured · Framed · Forever",
    },
    testimonials: {
      kicker: "Testimonials",
      title1: "What clients",
      title2: "say.",
    },
    cta: {
      kicker: "Ready to Create",
      title1: "Let's make your event",
      title2: "unforgettable.",
    }
  },
  about: {
    hero: {
      kicker: "About",
      title1: "A studio built for",
      title2: "real",
      title3: "moments.",
    },
    story: {
      quote: "\"Photobooths are simple. Turning them into unforgettable experiences — that's the craft.\"",
      p1: "KV Eventech was born in the coastal heart of Andhra Pradesh, where every celebration carries the weight of generations. We fell in love with a simple idea: the photograph is the most democratic heirloom. It belongs to everyone who looked into it.",
      p2: "Since then, we've built a studio that pairs craftsmanship with technology — from a perfectly lit classic booth to real-time AI artistry and live mosaic walls that turn a room full of strangers into a single, breathtaking image.",
      p3: "We approach every event as a collaboration, not a contract. Your story, our craft, beautifully woven into each frame.",
    },
    values: [
      { t: "Craft", d: "Each element — light, backdrop, template, frame — chosen with intention." },
      { t: "Care", d: "We treat every guest like a guest of honour. Always." },
      { t: "Curiosity", d: "We test, learn and iterate — every event pushes the craft forward." },
    ],
    stats: [
      { k: "Many", l: "Events Crafted" },
      { k: "12", l: "Cities Served" },
      { k: "07", l: "Signature Services" },
      { k: "98%", l: "Client Love" },
    ]
  },
  services: {
    hero: {
      kicker: "Services — 07 Offerings",
      title1: "What we",
      title2: "create.",
      desc: "Seven premium services, one commitment — to make every moment of your event unforgettable. Each offering is crafted with precision and tuned to the tone and scale of your celebration.",
    },
    compareTable: {
      kicker: "At a Glance",
      title1: "Compare",
      title2: "all services.",
    },
    cta: {
      title1: "Ready to create something",
      title2: "extraordinary?",
    }
  },
  gallery: {
    hero: {
      kicker: "Captured Memories",
      title1: "Frames we are",
      title2: "proud of.",
      desc: "A curated selection from weddings, galas, product launches and festive celebrations across India. Tap any image to enter the lightbox.",
    }
  },
  contact: {
    hero: {
      kicker: "Book · Quote · Plan",
      title1: "Let's",
      title2: "build",
      title3: "your event.",
      desc: "Tell us your event date, guest count, and service interest — we'll come back with a personalised quote within 24 hours.",
    },
    steps: {
      s1: { title1: "What are we", title2: "celebrating?" },
      s2: { title1: "Which", title2: "services?" },
      s3: { title1: "How can we", title2: "reach you?" },
      s4: { title1: "Anything", title2: "specific?" },
    },
    success: {
      title: "Enquiry received.",
      desc: "We're opening WhatsApp for you to share your enquiry instantly — or we'll reach out within 24 hours."
    },
    aside: {
      preferDirect: "Prefer Direct?",
      leadTime: {
        kicker: "Lead Time",
        desc: "Book 2–3 weeks ahead for standard services; 4–6 weeks for Mosaic Walls.",
      },
      coverage: {
        kicker: "Coverage",
        desc: "Visakhapatnam · Hyderabad · Vijayawada · Guntur · Tirupati · pan-India on request.",
      }
    }
  }
};
